import { Mail } from 'lucide-react';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { NewslatterSubscribe } from '../../services/userServices';
import './Newsletter.css';

const Newsletter = () => {
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = (formData) => {
    setIsLoading(true);
    NewslatterSubscribe(formData)
      .then((response) => {
        if (response && response.data.status === true) {
          toast.success('Subscribed to newsletter!');
          reset();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch(() => {
        toast.error('An error occurred. Try again!');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section className="newsletter_section_wrapper">
      <div className="container-fluid">
        <div className="newsletter_section">
          {/* Text */}
          <div className="newsletter_text_wrapper">
            <div className="newsletter_icon_wrapper">
              <Mail className="newsletter_icon" size={50} />
            </div>
            <div className="newsletter_text_content text-center text-lg-start">
              <h4 className="newsletter_title ">Sign Up for Newsletter</h4>
              <p className="newsletter_text ">
                Get email updates about our latest shop and special offers.
              </p>
            </div>
          </div>

          {/* Form */}
          <form className="newsletter_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="newsletter_input_wrapper">
              <input
                type="email"
                placeholder="Enter your email"
                className="newsletter_email"
                {...register('email', {
                  required: true,
                  maxLength: 40,
                  pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                })}
              />
              <button
                type="submit"
                className="add_newsletter"
                disabled={isLoading}
              >
                {isLoading ? 'Loading...' : 'Subscribe'}
              </button>
            </div>
            {errors.email && (
              <p className="text-danger small mt-1">
                Please enter a valid email address
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
